import { Period, PortfolioApi } from "@iliotech/generated-api-v3";
import { API_BASE } from "../../constants/constants";
import { useQuery } from "react-query";
import { useGlobalPeriod } from "../context";
import moment from "moment";

export const useRiskExposure = ({
  portfolioId,
  frequency = "Daily",
  overridePeriod,
}: {
  portfolioId: string;
  frequency: "Monthly" | "Daily";
  overridePeriod?: Period;
}) => {
  const { period: contextPeriod } = useGlobalPeriod();
  const period = overridePeriod || contextPeriod;
  console.log({ period });
  const from = !!period?.from
    ? moment(period.from).format("YYYY-MM-DD")
    : undefined;
  const to = !!period?.to ? moment(period.to).format("YYYY-MM-DD") : undefined;

  const api = new PortfolioApi(undefined, `${API_BASE}/api`);

  return useQuery(
    ["portfolio-exposure", { portfolioId, to, from, frequency }],
    () =>
      api.getPortfolioMarketValueAndExposureHistory(
        portfolioId,
        frequency,
        from,
        to
      ),
    {
      enabled: !!portfolioId,
    }
  );
};
